var Network = {
    canvasId: null,
    vuecontrol: null,
    lstNode: [],
    lstRelation: [],
    nodeW: 20,
    nodeH: 20,
    dragNode: null,
    move: false,
    mouseX: 0,
    mouseY: 0,
    moving: [],
    zoom: 1,
    moveX: 0,
    moveY: 0,
    timer: null,


    getIconByName: function (name) {
        name = name.toLowerCase();
        let icon = "";
        if (name.indexOf("date") >= 0 || name.indexOf("birthday") >= 0 || name.indexOf("date") >= 0) {
            icon = "date.svg";
        } else if (name.indexOf("user") >= 0 || name.indexOf("assignee") >= 0 || name.indexOf("creator") >= 0) {
            icon = "people.svg"
        } else if (name.indexOf("phone") >= 0 || name.indexOf("tel") >= 0) {
            icon = "phone.svg";
        } else if (name.indexOf("mail") >= 0 || name.indexOf("send") >= 0 || name.indexOf("from") >= 0 || name.indexOf("to") >= 0) {
            icon = "email.svg";
        } else if (name.indexOf("address") >= 0 || name.indexOf("location") >= 0) {
            icon = "address.svg";
        } else if (name.indexOf("card") >= 0 || name.indexOf("credit") >= 0 || name.indexOf("atm") >= 0) {
            icon = "card.svg";
        } else {
            icon = "data.png";
        }
        icon = "/img/network/" + icon;

        return icon
    },

    addNode: function (node, ischild) {
        let hasItem = false;
        for (let i = 0; i < this.lstNode.length; i++) {
            if (this.lstNode[i].id == node.id) {
                hasItem = true;
            }
        }
        //console.log(hasItem);
        if (!hasItem) {
            if (ischild == undefined || ischild == false) {
                node.type = "object";
                let addnode = {
                    id: node.id,
                    title: node.infini_title,
                    icon: Network.getIconByName(node.infini_type),
                    content: node,
                    show: false
                };
                Network.lstNode.push(addnode);
            } else {
                Network.lstNode.push(node);
            }
            //
            // add property node
            //
            if (ischild == undefined || ischild == false) {
            }
            return true;
        } else {
            return false;
        }
    },

    getMousePoint: function (event, containerId) {

        /*
                let container = document.getElementById(containerId);
                let rect = container.getBoundingClientRect();
                let doc = document.documentElement;
                let docleft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
                let doctop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

                console.log(docleft+"-"+doctop);
        */

        let top = event.offsetY;
        let left = event.offsetX;
        return {x: left, y: top};

    },

    init: function (canvasId, vue, nodes, lstRelation) {
        this.canvasId = canvasId;
        this.vuecontrol = vue;
        this.lstNode = [];
        this.lstRelation = lstRelation;
        this.move = false;
        this.dragNode = null;
        this.moving = [];
        this.zoom = 1;
        this.moveX = 0;
        this.moveY = 0;
        //
        // set drag
        //
        let canvas = document.getElementById(canvasId);
        console.log(canvas);
        //canvas.setAttribute("draggable",true);
        canvas.onmousedown = function (e) {
            Network.move = true;
            Network.mouseX = e.clientX;
            Network.mouseY = e.clientY;
        }

        canvas.onmouseup = function (e) {
            if (Network.move == true) {
                Network.move = false;
                Network.moveX = Network.moveX + Network.mouseX - e.clientX;
                Network.moveY = Network.moveY + Network.mouseY - e.clientY
            }
        }

        canvas.onmousemove = function (e) {
            //console.log(e);

            if (Network.dragNode != null) {
                let mouseP = Network.getMousePoint(e, Network.canvasId);
                Network.dragNode.x = (mouseP.x + Network.moveX) / Network.zoom;
                Network.dragNode.y = (mouseP.y + Network.moveY) / Network.zoom;
                Network.redrawNode(Network.dragNode);
                //Network.redraw(Network.dragNode);
            } else if (Network.move) {
                let canvas = document.getElementById(Network.canvasId);
                let mx = e.clientX;
                let my = e.clientY;
                let nx = Network.moveX + Network.mouseX - mx;
                let ny = Network.moveY + Network.mouseY - my;
                let viewBox = nx + " " + ny + " 1000 1000";
                canvas.setAttribute("viewBox", viewBox);

            }
        }

        canvas.ondragend = function (e) {
            console.log("end drag");
        }

        for (let i = 0; i < nodes.length; i++) {
            this.addNode(nodes[i], false);
        }

        this.draw();
    },

    createElement: function (tagname) {
        return document.createElementNS("http://www.w3.org/2000/svg", tagname);
    },

    removeNode: function (node) {
        let hasItem = false;
        for (let i = 0; i < lstNode.length; i++) {
            if (lstNode[i].id == node.id) {
                hasItem = true;
                lstNode.splice(i, 1);
                break;
            }
        }
        if (!hasItem) {
            this.draw();
        }
    },

    adjustPositionNotFinish: function () {
        let i, j;
        //
        // remove no way in node
        //
        let network = [];
        let relations = [];
        /*
                for(i=0;i<Network.lstNode.length;i++){
                    network.push(Network.lstNode[i]);
                }
                for(i=0;i<Network.lstRelation.length;i++){
                    relations.push(Network.lstRelation[i]);
                }
        */
        network = Network.lstNode;
        relations = Network.lstRelation;

        let noItemRemove;
        do {
            noItemRemove = true;
            for (i = network.length - 1; i >= 0; i--) {
                let countEdge = 0;
                for (j = 0; j < relations.length; j++) {
                    if (relations[j].node1 == network[i].id || relations[j].node2 == network[i].id) {
                        countEdge++;
                    }
                }
                if (countEdge <= 1) {
                    //
                    // remove node
                    //
                    for (j = 0; j < relations.length; j++) {
                        if (relations[j].node1 == network[i].id || relations[j].node2 == network[i].id) {
                            relations.splice(j, 1);
                        }
                    }
                    network.splice(i, 1);
                    noItemRemove = false;
                }
            }
        } while (!noItemRemove);
        //
        //set node position
        //
        let centerx = 0;
        let centery = 0;
        let done = false;
        let edge = [];
        for (i = 0; i < network.length; i++) {
            let arr1 = [];
            for (j = 0; j < network.length; j++) {
                arr1[i].push(0);
            }
            edge.push(arr1);
        }

        for (i = 0; i < network.length; i++) {
            for (j = 0; j < network.length; j++) {
                edge[i][j] = 0;
                for (let h = 0; h < relations.length; h++) {
                    if (relations[h].node1 == network[i].id && relations[h].node2 == network[j].id) {
                        edge[i][j] = 1;
                        break;
                    }
                }
            }
        }

        do {
            let polygon = [network[0]];
            for (i = 0; i < network.length; j++) {
            }
        } while (!done);
        Network.draw();
    },

    adjustPosition: function () {
        let i, j;
        //
        // remove no way in node
        //
        let network = [];
        let relations = [];

        for (i = 0; i < Network.lstNode.length; i++) {
            network.push(Network.lstNode[i]);
        }
        for (i = 0; i < Network.lstRelation.length; i++) {
            relations.push(Network.lstRelation[i]);
        }

        for (i = 0; i < network.length; i++) {
            network[i].weight = 0;
            for (j = 0; j < relations.length; j++) {
                if (relations[j].node1 == Network.lstNode[i].id || relations[j].node2 == network[i].id) {
                    network[i].weight++;
                }
            }
        }

        let nodes = [];
        nodes.push(network[0]);
        network.splice(0, 1);
        nodes[0].layer = 0;
        let start = 0;
        let maxlayer = 0;
        do {
            for (j = relations.length - 1; j >= 0; j--) {
                if (relations[j].node1 == nodes[start].id || relations[j].node2 == nodes[start].id) {
                    for (i = network.length - 1; i >= 0; i--) {
                        if (relations[j].node1 == network[i].id || relations[j].node2 == network[i].id) {
                            network[i].layer = nodes[start].layer + 1;
                            network[i].previous = nodes[start];
                            if (network[i].layer > maxlayer) {
                                maxlayer = network[i].layer;
                            }

                            nodes.push(network[i]);
                            network.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            start++;
            if (start >= nodes.length && network.length > 0) {
                network[0].layer = 0;
                nodes.push(network[0]);
                network.splice(0, 1);
            }
        } while (network.length > 0);

        let cx = 300;
        let cy = 300;
        let radius = 150;
        let x, y, alpha;
        /*
                for (i = 0; i <= maxlayer; i++) {
                    let count = 0;
                    for (j = 0; j < nodes.length; j++) {
                        if (nodes[j].layer == i) {
                            count++;
                        }
                    }
                    let angle =0;
                    for (j = 0; j < nodes.length; j++) {
                        if (nodes[j].layer == i) {
                            if (nodes[j].previous == undefined || nodes[j].previous == null) {
                                x = cx;
                                y = cy;
                                alpha = 0;
                            } else {
                                x = nodes[j].previous.x;
                                y = nodes[j].previous.y;
                                alpha = nodes[j].previous.alpha;
                            }

                            nodes[j].alpha = alpha + angle * 2 * Math.PI / count;
                            nodes[j].x = x + Math.floor(radius * Math.cos(nodes[j].alpha));
                            nodes[j].y = y + Math.floor(radius * Math.sin(nodes[j].alpha));
                            angle++;
                            nodes[j].title = nodes[j].title + "(layer:"+i+")";
                        }
                    }
                }
        */
        let count =0;
        //console.log(nodes);
        for(i=0;i<nodes.length;i++) {
            if(nodes[i].layer == 0) {
                count++;
                nodes[i].predictX = count * cx;
                nodes[i].predictY = cy;
                nodes[i].alpha = 0;
            }
        }
        for (i = 0; i < nodes.length; i++) {
            count = 0;
            x = nodes[i].predictX;
            y = nodes[i].predictY;
            alpha = nodes[i].alpha;
            for (j = i + 1; j < nodes.length; j++) {
                if(nodes[j].previous != undefined && nodes[j].previous != null) {
                    if (nodes[j].previous.id == nodes[i].id) {
                        count++;
                    }
                }
            }
            let angle = -(count - 1) / 2.0;
            for (j = i + 1; j < nodes.length; j++) {
                if(nodes[j].previous != undefined && nodes[j].previous != null) {
                    if (nodes[j].previous.id == nodes[i].id) {
                        console.log("angle:" + angle);
                        nodes[j].alpha = alpha + angle * 2 * Math.PI / (count * (nodes[i].layer + 1));
                        //console.log("alpha:" + nodes[j].alpha * 180 / Math.PI);
                        //Network.moveNode(nodes[j].id,x + Math.floor(radius * Math.cos(nodes[j].alpha)),y + Math.floor(radius * Math.sin(nodes[j].alpha)))

                        nodes[j].predictX = x + Math.floor(radius * Math.cos(nodes[j].alpha));
                        nodes[j].predictY = y + Math.floor(radius * Math.sin(nodes[j].alpha));

                        angle++;
                        //nodes[j].title = nodes[j].title +":"+Math.floor(nodes[j].alpha*180/Math.PI);
                    }
                }
            }
        }
        for (i = 0; i < nodes.length; i++) {
            if (nodes[i].x == undefined || nodes[i].x == null) {
                nodes[i].x = nodes[i].predictX;
            }
            if (nodes[i].y == undefined || nodes[i].y == null) {
                nodes[i].y = nodes[i].predictY;
            }
            Network.moveNode(nodes[i].id, nodes[i].predictX, nodes[i].predictY);
        }

        //console.log(nodes);
        //console.log(Network.lstNode);
        //Network.draw();
    },

    onZoom: function (zoom) {
        Network.zoom = zoom;
        Network.draw();
    },

    drawNode: function (canvas, node) {
        let x = node.x * Network.zoom;
        let y = node.y * Network.zoom;
        let g = this.createElement("g");
        g.setAttribute("id", "node_" + node.id);
        canvas.appendChild(g);
        let circle = this.createElement("circle");
        g.appendChild(circle);
        circle.setAttribute("cx", x);
        circle.setAttribute("cy", y);
        circle.setAttribute("r", this.nodeW * Network.zoom);
        circle.setAttribute("stroke-width", 3);
        if (node.type == "property") {
            circle.setAttribute("stroke", "#F5F5F5");
            circle.setAttribute("fill", "rgba(255,255,255,0.8)");
        } else {
            circle.setAttribute("stroke", "SteelBlue");
            circle.setAttribute("fill", "rgba(64,224,208,0.8)");
        }
        let image = this.createElement("image");
        if (node.icon == undefined) {
            node.icon = "data.png";
        }
        image.setAttribute("href", node.icon);
        image.setAttribute("x", x - this.nodeW * this.zoom / 2);
        image.setAttribute("y", y - this.nodeH * this.zoom / 2);
        image.setAttribute("width", this.nodeW * this.zoom);
        image.setAttribute("height", this.nodeH * this.zoom);
        g.appendChild(image);
        let text = this.createElement("text");
        g.appendChild(text);
        text.innerHTML = node.title;
        text.setAttribute("x", x - this.nodeW * this.zoom)
        text.setAttribute("y", y + 2 * this.nodeH * this.zoom);
        let fontSize = 8 * this.zoom;
        text.setAttribute("style", "font-family:Arial; font-size: " + fontSize + "pt; fill: black");
        //
        // event processing
        //
        g.setAttribute("draggable", true);
        //g.setAttribute("stroke","lightsalmon");
        g.ondragstart = function (e) {
            console.log("g start drag");
        }

        g.ondragend = function (e) {
            console.log("g end drag");
        }

        g.onmousedown = function (event) {
            if (event.button == 0) {
                Network.dragNode = node;
            } else {
                console.log(event.button);
                console.log(node);
                if (node.type == "property") {
                    //
                    // is property node
                    //
                    if (node.show == undefined || node.show == false) {
                        Network.vuecontrol.topoSearch(node.id, node.content);
                        node.show = true;
                    } else {
                        Network.removeChildOfNode(node);
                        Network.draw();
                    }
                } else {
                    //
                    // is data node, show and hide property
                    //
                    Network.showHideProperty(node.id);
                }
            }
            event.stopPropagation();
        }

        g.oncontextmenu = function (event) {
            event.preventDefault();
        }

        g.onmouseup = function () {
            Network.dragNode = null;
            //event.preventDefault();
            event.stopPropagation();
        }
    },

    findNodeById: function (id) {
        for (let i = 0; i < this.lstNode.length; i++) {
            if (this.lstNode[i].id == id) {
                return this.lstNode[i];
            }
        }
        return null;
    },

    drawRelation: function (canvas, relation) {
        let node1 = this.findNodeById(relation.node1);
        if (node1 == null) {
            return;
        }
        let node2 = this.findNodeById(relation.node2);
        if (node2 == null) {
            return;
        }
        ;
        //
        // assure that all node not null
        //
        let x1 = node1.x * this.zoom,
            y1 = node1.y * this.zoom,
            x2 = node2.x * this.zoom,
            y2 = node2.y * this.zoom;
        let line = this.createElement("line");
        line.setAttribute("id", relation.node1 + "_" + relation.node2);
        if (relation.type == "child") {
            line.setAttribute("stroke-width", "1");
            line.setAttribute("stroke", "LightCoral");
        } else {
            line.setAttribute("stroke-width", "1");
            line.setAttribute("stroke", "MidnightBlue");
        }
        line.setAttribute("x1", x1);
        line.setAttribute("y1", y1);
        line.setAttribute("x2", x2);
        line.setAttribute("y2", y2);
        canvas.appendChild(line);

    },

    clear: function () {
        this.clearCanvas();
        Network.lstRelation = [];
        Network.lstNode = [];
    },

    clearCanvas: function () {
        let canvas = document.getElementById(this.canvasId);
        if (canvas == null) {
            return;
        }
        canvas.innerHTML = "";
    },

    finishMove: function (id) {
        for (let i = Network.moving.length - 1; i >= 0; i--) {
            if (Network.moving[i].id == id) {
                clearInterval(Network.moving[i].interval);
                this.moving.splice(i, 1);
            }
        }
    },

    startMove: function () {
        if (Network.moving.length == 0) {
            clearInterval(Network.timer);
            Network.timer = null;
            return;
        }
        for (let i = Network.moving.length - 1; i >= 0; i--) {
            let move = Network.moving[i];
            if (move.node.x == move.x && move.node.y == move.y) {
                Network.moving.splice(i, 1);
            } else {
                let xspace = move.x - move.node.x;
                let yspace = move.y - move.node.y;
                if (Math.abs(move.x - move.node.x) <= 5) {
                    move.node.x = move.x;
                } else {
                    let step = Math.floor(move.x - move.node.x) / 4;
                    if (step > 5) {
                        step = 5;
                    }
                    move.node.x += step;
                }
                if (Math.abs(move.y - move.node.y) <= 5) {
                    move.node.y = move.y;
                } else {
                    let step = Math.floor((move.y - move.node.y) / 4);
                    if (step > 5) {
                        step = 5;
                    }
                    move.node.y += step;
                }
                Network.redrawNode(move.node);
            }
        }
        //Network.draw();
    },

    moveNode: function (id, x, y) {
        let move = null;
        for (let i = 0; i < this.lstNode.length; i++) {
            if (this.lstNode[i].id == id) {
                move = {
                    id: id,
                    node: this.lstNode[i],
                    x: x,
                    y: y
                }
                Network.finishMove(id);
                this.moving.push(move);
                break;
            }
        }
        if (Network.timer == null) {
            Network.timer = setInterval(Network.startMove, 10);
        }
    },

    redrawNode: function (node) {
        let x = node.x * Network.zoom;
        let y = node.y * Network.zoom;

        let g = document.getElementById("node_" + node.id);
        let circle = g.childNodes[0];
        circle.setAttribute("cx", x);
        circle.setAttribute("cy", y);
        let image = g.childNodes[1];
        image.setAttribute("x", x - Network.nodeW * Network.zoom / 2);
        image.setAttribute("y", y - Network.nodeH * Network.zoom / 2);

        let text = g.childNodes[2];
        text.setAttribute("x", x - Network.nodeW * Network.zoom)
        text.setAttribute("y", y + 2 * Network.nodeH * Network.zoom);
        //
        // redraw all relation
        //
        for (let i = 0; i < Network.lstRelation.length; i++) {
            if (Network.lstRelation[i].node1 == node.id) {
                let relationId = Network.lstRelation[i].node1 + "_" + Network.lstRelation[i].node2;
                let line = document.getElementById(relationId);
                line.setAttribute("x1", x);
                line.setAttribute("y1", y);
            } else if (Network.lstRelation[i].node2 == node.id) {
                let relationId = Network.lstRelation[i].node1 + "_" + Network.lstRelation[i].node2;
                let line = document.getElementById(relationId);
                line.setAttribute("x2", x);
                line.setAttribute("y2", y);
            }
        }

    },

    draw: function () {
        this.clearCanvas();
        let canvas = document.getElementById(this.canvasId);
        if (canvas == null) {
            return;
        }
        for (let i = 0; i < this.lstRelation.length; i++) {
            this.drawRelation(canvas, this.lstRelation[i]);
        }
        for (let i = 0; i < this.lstNode.length; i++) {
            this.drawNode(canvas, this.lstNode[i]);
        }
    },

    removeChildOfNode: function (node) {
        let i,j,h;
        node.show = false;
        for (i = Network.lstRelation.length - 1; i >= 0; i--) {
            if (Network.lstRelation[i].node1 == node.id) {
                for (j = Network.lstNode.length - 1; j >= 0; j--) {
                    if (Network.lstNode[j].id == Network.lstRelation[i].node2) {
                        //
                        // check has other relation
                        //
                        let hasOther = false;
                        for (h = 0; h < Network.lstRelation.length; h++) {
                            if (h == i) {
                                continue;
                            }
                            if (Network.lstRelation[h].node1 == Network.lstNode[j].id || Network.lstRelation[h].node2 == Network.lstNode[j].id) {
                                hasOther = true;
                            }
                        }
                        if (!hasOther) {
                            Network.lstNode.splice(j, 1);
                            Network.lstRelation.splice(i, 1);
                        }
                        break;
                    }
                }
            }
        }
    },

    showHideProperty: function (nodeid) {
        let i, j, h;
        let node = null;
        for (i = Network.lstNode.length - 1; i >= 0; i--) {
            if (Network.lstNode[i].id == nodeid) {
                node = Network.lstNode[i];
                break;
            }
        }
        if (node.type == "property") {
            return;
        }
        //console.log("show hide node");
        //console.log(node);
        if (node.show == true) {
            Network.removeChildOfNode(node);
        } else {
            node.show = true;
            let count = 0;
            if(node.alpha == undefined || node.alpha == null){
                node.alpha =0 ;
            }
            for (var x in node.content) {

                if (x == "title" || x == "x" || x == "y" || x == "id" || x == "type" || x == "icon" || x == "_version_" || x.indexOf("infini") >= 0) {
                    continue;
                }
                count++;
            }
            let i = 0;
            let radian = 150;
            let angle =  -(count - 1) / 2.0;
            for (var x in node.content) {

                if (x == "title" || x == "x" || x == "y" || x == "id" || x == "type" || x == "icon" || x == "_version_" || x.indexOf("infini") >= 0) {
                    continue;
                }
                let nodeAngle = node.alpha + angle * 2 * Math.PI / (count * (node.layer + 1));
                let childNode = {
                    "id": x + ":" + node.content[x],
                    "title": x + ":" + node.content[x],
                    "content": node.content[x],
                    "alpha": nodeAngle,
                    "x": node.x + Math.cos(nodeAngle) * radian,
                    "y": node.y + Math.sin(nodeAngle) * radian,
                    "icon": Network.getIconByName(x),
                    "type": "property"
                }
                if (Network.addNode(childNode, true)) {
                    let relation = {
                        node1: node.id,
                        node2: childNode.id,
                        type: "child"
                    }
                    Network.lstRelation.push(relation);
                }
                angle++;
            }
        }
        this.draw();
    },

    saveSVG: function () {
        var svgData = document.getElementById(Network.canvasId).outerHTML;
        var svgBlob = new Blob([svgData], {type: "image/svg+xml;charset=utf-8"});
        var svgUrl = URL.createObjectURL(svgBlob);
        var downloadLink = document.createElement("a");
        downloadLink.href = svgUrl;
        downloadLink.download = "deepsearch.svg";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
}

export default Network;